import { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { CSSTransition } from 'react-transition-group';

import {
    MdKeyboardArrowUp,
    MdKeyboardArrowDown,
    MdFilterList,
} from 'react-icons/md';

import './Collapsible.css';

const Collapsible = ({
    title,
    open = false,
    children,
    extraClass = '',
    isFilter = false,
}) => {
    const [isOpen, setIsOpen] = useState(open);
    const nodeRef = useRef(null);

    // TODO: WRAP EVERYTHING INSIDE CSSTransition AND
    // ANIMATE THE ARROWS AS WELL

    return (
        <div
            className="ab-collapsible"
            role="button"
            tabIndex="0"
            aria-expanded="true"
            aria-label=""
        >
            <div
                className="ab-collapsible-header"
                onClick={() => setIsOpen(!isOpen)}
            >
                <div className="ab-collapsible-title">{title}</div>
                <div className="ab-collapsible-icon">
                    {isFilter ? (
                        isOpen ? (
                            <MdFilterList size={20} />
                        ) : (
                            <MdFilterList size={20} />
                        )
                    ) : isOpen ? (
                        <MdKeyboardArrowUp size={20} />
                    ) : (
                        <MdKeyboardArrowDown size={20} />
                    )}
                </div>
            </div>
            <CSSTransition
                nodeRef={nodeRef}
                in={isOpen}
                timeout={300}
                classNames="ab-collapsible-body-animate"
                unmountOnExit
            >
                <div
                    className={`ab-collapsible-body ${extraClass} ${
                        isOpen ? 'ab-collapsible-body-animate-enter-done' : ''
                    } `}
                    ref={nodeRef}
                >
                    {children}
                </div>
            </CSSTransition>
        </div>
    );
};

Collapsible.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    open: PropTypes.bool,
    isFilter: PropTypes.bool,
    children: PropTypes.node,
    extraClass: PropTypes.string,
};

export default Collapsible;
